
import { Metric, MonthlySales, TopSellingProducts } from "../../Domain/Model/Metric";
import { MetricRepository } from "../../Domain/Repository/MetricRepository";
import MetricDataSource from "../DataSource/MetricDataSource";

export class MetricRepositoryImpl implements MetricRepository {
  dataSource: MetricDataSource;

  constructor(_datasource: MetricDataSource) {
    this.dataSource = _datasource;
  }
  getMonthlySales(year: number): Promise<MonthlySales[]> {
    return this.dataSource.getMonthlySales(year);
  }
  getMetrics(): Promise<Metric> {
    return this.dataSource.getMetrics();
  } 
  getLowStockProducts(): Promise<TopSellingProducts[]> {
     return this.dataSource.getLowStockProducts();
  }
}